export default __webpack_public_path__ + "static/media/Rectangle 1698.4c31ee74.png";